import * as React from 'react';
import { ActionButton, fetchApi, notifyError, notifyResponse } from 'gossamer-front-end';
import { AdminOrgUnitEventRemoveRequest, OrgUnitEvent, OrgUnitEventView } from 'cb-model';

export interface RemoveEventFromOrgUnitButtonProps {
  value: string; // org unit event id
  handleSuccess?: () => void;
}

export const RemoveEventFromOrgUnitButton: React.FC<RemoveEventFromOrgUnitButtonProps> = (props) => {
  return (
    <ActionButton
      label="Remove from Org Unit"
      size="sm"
      variant="danger"
      waiting={false}
      execute={async (resetCache) => {
        try {
          const response = await fetchApi('POST', `/main/org-unit-event-remove`, {
            orgUnitEventId: Number(props.value),
          } as AdminOrgUnitEventRemoveRequest);
          resetCache(OrgUnitEvent.id, props.value);
          resetCache(OrgUnitEventView.id, props.value);
          notifyResponse(response);
          if (props.handleSuccess) {
            props.handleSuccess();
          }
        } catch (e) {
          notifyError(e, 'An error occurred while removing the event from the org unit');
        }
      }}
    />
  );
};
